// @flow
import React, { PureComponent } from "react";
import PotencialReturn from "@fdr/static-ui/SvgImages/PotencialReturn";
import { InlineMessage } from "../../_molecules/MessageV2";
import {
  HelpContainer,
  HelpImageContainer,
  HelpTextContainer,
  TextParaf,
  InlineMessageWrapper
} from "./styled-components";

export type Props = {
  paraf1: string,
  paraf2: string,
  paraf3: string,
  infoMessage: string,
  hasMessage: boolean
};

export default class PotencialReturnHelp extends PureComponent<Props> {
  static defaultProps = {
    paraf1: "",
    paraf2: "",
    paraf3: "",
    infoMessage: "asds",
    hasMessage: false
  };

  render() {
    return (
      <HelpContainer>
        <HelpImageContainer>
          <PotencialReturn />
        </HelpImageContainer>
        {this.props.hasMessage && (
          <InlineMessageWrapper>
            <InlineMessage type="info" text={this.props.infoMessage} />
          </InlineMessageWrapper>
        )}
        <HelpTextContainer hasMessage={this.props.hasMessage}>
          <TextParaf>{this.props.paraf1}</TextParaf>
          <TextParaf>{this.props.paraf2}</TextParaf>
          <TextParaf>{this.props.paraf3}</TextParaf>
        </HelpTextContainer>
      </HelpContainer>
    );
  }
}
